import React, { useState } from 'react';
import axios from 'axios';
import './AddSchemePop.css';
import { useDispatch, useSelector } from 'react-redux';
import { setAdditionalCustomerId } from '../../Redux/store/authSlice';
import warningIcon from '../common/asset1/warning-symbol.svg';
 
const AddSchemePop = ({ show, onClose, onProceed }) => {
  const [networkSuccess, setNetworkSuccess] = useState(false);
  console.log('Props in AddSchemePop:', { show, onClose, onProceed });
  const [formData, setFormData] = useState({
    userName: '',
    mobileNumber: '',
    customerId:'',
  });
  const userToken = useSelector((state) => state.auth.token);
  const [responseData, setResponseData] = useState(null);
  const dispatch = useDispatch();
  const additionalCustomerId = useSelector((state) => state.auth.additionalCustomerId);
  const [errors, setErrors] = useState({});
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.userName) {
      newErrors.userName = 'User Name is required';
    }
    if (!formData.customerId) {
      newErrors.customerId = 'Customer ID is required';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; 
  };
  
  const handleProceed = async () => {
    if (!validateForm()) {
      return; 
    }
    try {
      const requestData = { ...formData, customerId: formData.customerId ? parseInt(formData.customerId, 10) : null };
      console.log('Request Data:', requestData);
      const response = await axios.post(
        'https://localhost:7040/api/enrolledscheme/newschemeforexistinguser',
        requestData,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${userToken}`,
          },
          withCredentials: true,
        }
      );
      if (response.status === 200 || response.status === 204) {
        setResponseData(response.data);  
        alert('Scheme added successfully!');
        const customerId = response.data.customerId || requestData.customerId;
        console.log('Customer ID to dispatch:', customerId);
        dispatch(setAdditionalCustomerId(customerId));
        onProceed(customerId);
        setNetworkSuccess(true);  
      } else {
        alert('Unexpected response received.');
      }
    } catch (error) {
   
      if (error.response) {
        console.error('Server responded with an error:', error.response.data);
        alert(`Failed to add scheme: ${error.response.data.message || 'Please try again.'}`);
      } else if (error.request) {
        console.error('No response received:', error.request);
        alert('Failed to connect to the server. Please check your network.');
      } else {
        console.error('Error setting up the request:', error.message);
        alert('An unexpected error occurred. Please try again.');
      }
      setNetworkSuccess(false);  
    }
  };
  

  if (!show) return null;

  return (
    <div className="popup-overlay">
      <button onClick={onClose} className="close-button">&times;</button>
      <div className="popup-container">
        <div className="popup-header">
          <h2>User Details</h2>
        </div>
        <div className="popup-body">
          <div className="form-group">
          <label>User Name / Mobile Number</label>
  <input
    type="text"
    name="userName"
    value={formData.userName}
    onChange={handleChange}
    placeholder="Enter User Name or Mobile Number"
  />
  {errors.userName && (
    <div className="error-reg-icon-out">
      <img
        src={warningIcon}
        alt="Warning-Icon"
        className="warning-icon"
      />
      <span className="error-register-now">{errors.userName}</span>
    </div>
  )}
</div>
<div className="form-group">
  <label>Customer ID</label>
  <input
    type="text"
    name="customerId"
    value={formData.customerId}
    onChange={handleChange}
    placeholder="Enter Customer ID"
  />
  {errors.customerId && (
    <div className="error-reg-icon-out">
      <img
        src={warningIcon}
        alt="Warning-Icon"
        className="warning-icon"
      />
      <span className="error-register-now">{errors.customerId}</span>
    </div>
  )}
</div>
        
        </div>
        <div className="popup-2-bottom-scheme">
          <button onClick={handleProceed} className="proceed-button-add-scheme">Proceed</button>
          <button onClick={onClose} className="cancel-button">Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default AddSchemePop;
